import { Phone, UserRound } from "lucide-react";
import { Reveal } from "./Reveal";
import { CLINIC, DOCTORS } from "@/data/content";

export default function Doctors() {
  return (
    <section id="echipa" className="py-20 lg:py-28 bg-[#FBF7F0]">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-widest text-[#A6823B]">Echipa medicală</span>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-slate-900 mt-3">
            Medici cu experiență, dedicați pacienților
          </h2>
          <p className="text-slate-600 mt-4 text-lg">
            Medici cu experiență, dedicați sănătății tale. Programează o consultație telefonic.
          </p>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {DOCTORS.map((d, i) => (
            <Reveal key={d.name} delay={i * 0.07}>
              <div data-testid="doctor-card-profile"
                className="group bg-white rounded-2xl border border-slate-200 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all">
                {d.img ? (
                  <div className="aspect-[4/5] overflow-hidden bg-[#EFE7D6]">
                    <img src={d.img} alt={d.name} data-testid="doctor-photo"
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  </div>
                ) : (
                  <div className="aspect-[4/5] overflow-hidden bg-[#EFE7D6] flex flex-col items-center justify-center text-[#A6823B]" data-testid="doctor-photo-placeholder">
                    <UserRound className="w-16 h-16 opacity-50" />
                    <span className="text-xs mt-3 text-[#8A7A5E]">Fotografie în curând</span>
                  </div>
                )}
                <div className="p-5">
                  <span className="text-xs font-semibold text-[#A6823B] uppercase tracking-wide">{d.spec}</span>
                  <h3 className="font-display font-bold text-slate-900 mt-1">{d.name}</h3>
                  <p className="text-sm text-slate-500">{d.role}</p>
                  <a href={CLINIC.phoneRaw} className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#A6823B] hover:text-[#8A6B2E]">
                    <Phone className="w-4 h-4" /> Programează consult
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
